'use strict';

const throttle = require('lodash/throttle');
const breakpoints = require('../breakpoints');

module.exports = function () {
    if (!breakpoints.down('md')) {
        return;
    }

    const headerElement = document.querySelector('.js-header');

    const feedbackWrapper = document.querySelector('.feedback-element-wrapper');
    const feedbackWrapperHeaderNoMenu = document.querySelector('.feedback-element-wrapper-header-no-menu');

    const pdpMobileStickyPricesAndAddToCart = document.querySelector('.js-prices-add-to-cart-actions.sticky-mobil');
    const pdpMobileStickyPricesAndAddToCartHeight = pdpMobileStickyPricesAndAddToCart?.clientHeight || 0;

    let lastScrollY = window.scrollY;
    let isSticky = false;

    const updateFeedbackWrapperPosition = () => {
        if (!feedbackWrapper) {
            return;
        }

        if (breakpoints.down('sm')) {
            let feedbackWrapperBottom = 4;

            if (pdpMobileStickyPricesAndAddToCart) {
                feedbackWrapperBottom += pdpMobileStickyPricesAndAddToCartHeight;
            }

            feedbackWrapper.style.bottom = `${feedbackWrapperBottom}px`;
        }
    };

    const updateFeedbackWrapperHeaderNoMenuPosition = () => {
        if (!feedbackWrapperHeaderNoMenu || !breakpoints.down('md')) {
            return;
        }

        const isPlaceOrderStage = document.getElementById('checkout-main')?.dataset.checkoutStage === 'placeOrder';

        let fixedButton;
        if (isPlaceOrderStage) {
            fixedButton = document.querySelector('.js-next-step-button-placeorder.is-fixed')
                || document.querySelector('.js-scroll-to-next-step-button-placeorder.show');
        } else {
            fixedButton = document.querySelector('.js-next-step-button.is-fixed');
        }

        feedbackWrapperHeaderNoMenu.style.bottom = fixedButton
            ? `${4 + fixedButton.clientHeight}px`
            : '4px';
    };

    const handleScroll = () => {
        if (!headerElement) {
            return;
        }
        const currentScrollY = window.scrollY;

        if (currentScrollY < lastScrollY && !isSticky) {
            headerElement.classList.add('header--main-sticky');
            isSticky = true;
        } else if (currentScrollY >= lastScrollY && isSticky) {
            headerElement.classList.remove('header--main-sticky');
            isSticky = false;
        }

        lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', throttle(() => {
        requestAnimationFrame(handleScroll);
    }, 100));

    const observeMutations = (target, callback, options = {}, wait = 100) => {
        const throttledCallback = throttle(callback, wait);

        const observer = new MutationObserver((mutations, obs) => {
            throttledCallback(mutations, obs);
        });

        observer.observe(target, {
            childList: true,
            subtree: true,
            ...options
        });

        return observer;
    };

    if (feedbackWrapper) {
        observeMutations(
            feedbackWrapper,
            () => {
                updateFeedbackWrapperPosition();
            },
            {}
        );
    }

    if (feedbackWrapperHeaderNoMenu) {
        const checkoutStageEl = document.querySelector('[data-checkout-stage]');

        if (checkoutStageEl) {
            observeMutations(
                checkoutStageEl,
                (mutations) => {
                    mutations.forEach((mutation) => {
                        if (
                            mutation.type === 'attributes'
                            && mutation.attributeName === 'data-checkout-stage'
                        ) {
                            updateFeedbackWrapperHeaderNoMenuPosition();
                        }
                    });
                },
                {
                    attributes: true,
                    attributeFilter: ['data-checkout-stage'],
                    attributeOldValue: true
                }
            );
        }

        document.querySelectorAll('.js-next-step-button, .js-scroll-to-next-step-button-placeorder').forEach((btn) => {
            new MutationObserver(updateFeedbackWrapperHeaderNoMenuPosition)
                .observe(btn, { attributes: true, attributeFilter: ['class'] });
        });
    }
};
